import React from 'react';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';

import VpButton from '../VpButton';

const buttonStyles = {
  gap: '5px',
  padding: '5px 10px'
};

export const VpTabButtonGroup = ({
  first = '',
  second = '',
  selected = false,
  onSelect = () => {},
  ...rest
}) => {
  const handleClick = (value) => {
    onSelect(value);
  };

  const calculateProps = (compareValue) =>
    compareValue === selected
      ? {
          color: 'info',
          variant: 'contained'
        }
      : {
          color: 'neutral'
        };

  return (
    <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between" {...rest}>
      <VpButton onClick={() => handleClick(false)} sx={buttonStyles} {...calculateProps(false)}>
        {first}
      </VpButton>
      <VpButton onClick={() => handleClick(true)} sx={buttonStyles} {...calculateProps(true)}>
        {second}
      </VpButton>
    </Stack>
  );
};

VpTabButtonGroup.propTypes = {
  first: PropTypes.node,
  second: PropTypes.node,
  selected: PropTypes.bool,
  onSelect: PropTypes.func
};

export default VpTabButtonGroup;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTabButtonGroup/VpTabButtonGroup.jsx